import styled from "styled-components"

export const StyledRightArrow = styled.p`
  padding: 0 20px;
`
